import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "input", "container"]

    connect() {
        this.initializeState()
    }

    initializeState() {
        const currentValue = this.inputTarget.value

        // Check if select has this option
        let optionExists = false
        // Skip empty value checks for cleaner init
        if (currentValue) {
            for (let option of this.selectTarget.options) {
                if (option.value === currentValue) {
                    optionExists = true
                    break
                }
            }
        }

        // If value exists but isn't in dropdown, it's custom/other
        if (currentValue && !optionExists) {
            this.selectTarget.value = 'other'
            this.containerTarget.style.display = 'block'
        } else {
            // It's a standard option (or empty)
            this.selectTarget.value = currentValue || ''
            this.containerTarget.style.display = 'none'
        }
    }

    change() {
        const selectedValue = this.selectTarget.value

        if (selectedValue === 'other') {
            this.containerTarget.style.display = 'block'
            this.inputTarget.value = ''
            this.inputTarget.focus()
        } else {
            this.containerTarget.style.display = 'none'
            this.inputTarget.value = selectedValue
        }
    }
}
